import { Component, Input, EventEmitter, Output, OnDestroy } from '@angular/core';
import { IOrganisationsHierarchy, OrganisationDataService, OrganisationsHierarchy } from '@services/organisation-data.service';
import { EditHierarchyLocationComponent } from '@dialogs/edit-hierarchy-location/edit-hierarchy-location.component';
import { MatDialog } from '@angular/material/dialog';
import { Subject, distinctUntilChanged, filter, finalize, firstValueFrom, takeUntil } from 'rxjs';
import { GlobalFunctions, SnackType, imagePath, imgTypes } from '@global/GlobalFunctions';
import { siteSubscriptions } from '@services/siteSubscriptions';

/**
 * Component
 */
@Component({
	selector: 'app-hierarchy-sub-location',
	templateUrl: './hierarchy-sub-location.component.html',
	styleUrls: ['./hierarchy-sub-location.component.scss']
})
export class HierarchySubLocationComponent {

	/** Path to Sub Location Images */
	public imagePathSubLocations(): string {
		return imagePath(this.accountID, imgTypes.sublocations).toLowerCase()
	}

	/** Site Admin */
	@Input() AdminSite: boolean;
	/** child */
	@Input() child: OrganisationsHierarchy;
	/** accountID */
	@Input() accountID: string;
	/** OrganisationID */
	@Input() OrganisationID: string;
	/** selected */
	@Output() selected: EventEmitter<IOrganisationsHierarchy> = new EventEmitter<IOrganisationsHierarchy>();

	/**
	 * DEfault Constructor
	 * @param dialog dialog
	 * @param organisationDataService organisationDataService
	 * @param globalFunctions globalFunctions
	 * @param siteSubscriptions siteSubscriptions
	 */
	constructor(
		public dialog: MatDialog,
		private organisationDataService: OrganisationDataService,
		private globalFunctions: GlobalFunctions,
		private siteSubscriptions: siteSubscriptions
	) { }

	/**
	 * triggerEvent
	 * @param subLocation
	 */
	triggerEvent(subLocation: IOrganisationsHierarchy) {
		// Optionally, you can pass data along with the event
		const eventData: IOrganisationsHierarchy = subLocation;
		this.selected.emit(eventData);
	}

	/**
	 * Edit the Location details
	 * @param editLocation
	 */
	editLocation(editLocation: IOrganisationsHierarchy): void {
		// Create a local Subject to control the subscription lifecycle
		const fetchDataSubject = new Subject<void>();

		// Create a 'Local'/shallow copy of the Location Information
		var _edit = { ...editLocation };

		// Display the dialog box
		const dialogRef = this.dialog.open(EditHierarchyLocationComponent, {
			data: _edit,
		});

		// Update the original Location with the result
		dialogRef.afterClosed().pipe(
			filter(result => !!result)
		).subscribe(result => {
			// console.log('The dialog was closed');
			// Check we have a result to work with
			Object.assign(_edit, result);
			this.organisationDataService.patchOrganisationLocation$(this.accountID, this.OrganisationID, _edit).pipe(
				takeUntil(fetchDataSubject), distinctUntilChanged(),
				filter((response) => !!response),
				finalize(() => {
					// Ensure the subscription is terminated and the subject is completed
					fetchDataSubject.next();
					fetchDataSubject.complete();
				})
			).subscribe({
				next: (response) => {
					Object.assign(editLocation, result);
					this.rebuildOrganisationStructure(this.accountID, this.OrganisationID)
					// this.numberRND = Math.random()
					this.globalFunctions.DisplaySnackBar({
						message: "Location Details Updated",
						type: SnackType.Info,
						duration: 1000
					});
				}
			});
		});
	}

	/**
	 * Get the Organisation Structure
	 * @param AccountID AccountID
	 * @param OrganisationID OrganisationID
	 */
	async rebuildOrganisationStructure(AccountID: string, OrganisationUID: string) {
		try {
			let structure = await firstValueFrom(
				this.organisationDataService.getOrganisationStructure$(AccountID, OrganisationUID)
					.pipe(filter((response) => !!response)));
			if (structure) {
				var OrganisationStructure = <IOrganisationsHierarchy[]>JSON.parse(structure);
				this.siteSubscriptions.SethierarchicalData(OrganisationStructure);
			}
		}
		catch (error: any) {
			if (error["status"] != 404) {
				this.globalFunctions.HandleError(error, "Error: this.organisationDataService.getOrganisationStructure$", false)
			}
		}
	}
}
